import React, {useEffect, useState, Fragment, PropsWithChildren} from "react";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import {initReactI18next} from "react-i18next";
import {JSON_URL} from "modules/constants";
import {Preloader} from "components";
import {useDispatch} from "react-redux";
import {setLanguage} from "modules/actions";

export const HOCi18n: React.FC<PropsWithChildren> = ({children}) => {
	const [initialized, setInitialized] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		i18n.use(LanguageDetector)
			.use(Backend)
			.use(initReactI18next)
			.init(
				{
					/**
					 * i18nextBrowserLanguageDetector
					 */
					detection: {
						order: ["cookie", "localStorage", "sessionStorage", "navigator"],
					},
					supportedLngs: ["en", "is"],
					backend: {
						crossDomain: true,
						loadPath: `${JSON_URL}langs/{{lng}}.json`,
					},
					fallbackLng: "en",
					debug: false, // ENV !== "production",
					keySeparator: ".",
					interpolation: {
						escapeValue: false,
						formatSeparator: ",",
					},
				},
				() => {
					dispatch(setLanguage(i18n.language));
					setInitialized(true);
				}
			)
			.catch((err) => console.log(err));
	}, [dispatch]);

	return initialized ? <Fragment>{children}</Fragment> : <Preloader />;
};
